import { lazy } from "react";
import { durations } from "../../config/animations";

export default lazy(() =>
  Promise.all([import("./Search"), new Promise(r => setTimeout(r, durations.routeTransition + 40))]).then(m => m[0])
);
